import React from 'react';
import { RouterProvider } from 'react-router-dom';
import Loading from '@/components/Loading';
import useBrowserRouter from '@/hooks/useBrowserRouter';
import ErrorBoundary from '@/components/ErrorBoundary';

const Router = () => {
  const router = useBrowserRouter();
  return (
    <ErrorBoundary>
      <React.Suspense fallback={<Loading />}>
        <RouterProvider router={router} fallbackElement={<Loading />} />
      </React.Suspense>
    </ErrorBoundary>
  );
};

export default Router;
